import React, { useState } from "react";
import Popup from "../../Helpers/Popup/Popup";
import { Modal } from "react-bootstrap";
import PopupTitle from "../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../Helpers/CloseBtn/Close";
import UploadFile from "../../Helpers/Dropzone/UploadFile";
import PreviewFile from "./PreviewFile";
import { InputParentGroup } from "../../Helpers/Input/Input";
import trans from "../../../utils";
import Button from "../../Helpers/Button/Button";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useBulkUploadVehiclesMutation } from "../../../Redux/service/Vehicles/Vehicles";
import { toast } from "react-toastify";
import ExcelEditor from "../../Helpers/Excel/ExcelEditor";
import * as XLSX from "xlsx";

const VehicleBulkUpload = ({ bulkUpload, setBulkUpload }) => {
	const [uploadVehicleFile, { isLoading, isSuccess, error }] =
		useBulkUploadVehiclesMutation();
	const [duplicateImeis, setDuplicateImeis] = useState([]);
	const [hasError, setHasError] = useState("");
	const [errorVehicles, setErrorVehicles] = useState([]);

	const initialValues = {
		parent: "",
		file: [],
		parsedData: [],
		duplicateImeis: [],
	};
	const validationSchema = Yup.object({
		parent: Yup.string().required(trans("This field is required")),
		file: Yup.array()
			.min(1, trans("Please attach file"))
			.required(trans("File is required")),
	});
	// const handleSubmit = async (values) => {
	//   const formData = new FormData();
	//   formData.append("file", values.file[0]); // assuming only one file
	//   formData.append("parentId", values.parent);
	//   try {
	//     const res = await uploadVehicleFile(formData).unwrap();
	//     if (res.message === "Vehicles created successfully.") {
	//       setBulkUpload(false);
	//       toast.success(trans("File uploaded successfully"));
	//       setDuplicateImeis([]);
	//       setErrorVehicles([]);
	//       setHasError("");
	//       values.setFieldValue("file", []);
	//       values.setFieldValue("parsedData", []);
	//       values.setFieldValue("parent", "");
	//     }
	//   } catch (err) {
	//     if (
	//       err?.status === 409 &&
	//       err?.data?.message.includes("Duplicate IMEIs")
	//     ) {
	//       const duplicateImeis = err.data.message.match(/\d+/g); // extract all numbers
	//       toast.error(trans("Duplicate IMEIs found"));
	//       setDuplicateImeis(duplicateImeis);
	//       setHasError(trans("Duplicate IMEIs found"));
	//     } else if (err?.status === 400 && Array.isArray(err?.data?.errors)) {
	//       const allErrors = err.data.errors.flatMap((e) => e.errors);

	//       const requiredFields = allErrors
	//         .filter((msg) => msg.includes("is required"))
	//         .map((msg) => msg.match(/"([^"]+)"/)?.[1])
	//         .filter(Boolean);

	//       const otherMessages = allErrors
	//         .filter((msg) => !msg.includes("is required"))
	//         .map((msg) => msg.replace(/^"|"$/g, "")); // Clean up quotes

	//       const uniqueRequiredFields = [...new Set(requiredFields)];
	//       const uniqueOtherMessages = [...new Set(otherMessages)];

	//       let combinedMessage = "";

	//       if (uniqueRequiredFields.length) {
	//         combinedMessage += `${uniqueRequiredFields.join(", ")} ${trans(
	//           "columns are required"
	//         )}`;
	//       }

	//       if (uniqueOtherMessages.length) {
	//         if (combinedMessage) combinedMessage += " - ";
	//         combinedMessage += trans(uniqueOtherMessages[0]);
	//       }
	//       console.log(uniqueOtherMessages);
	//       toast.error(combinedMessage);
	//       setHasError(combinedMessage);

	//       const errorVehicleNames = err.data.errors.map((e) => e.vehicle);
	//       const parsedRowNames = values.parsedData.map((row) => row.name);
	//       const matchedRows = parsedRowNames.filter((name) =>
	//         errorVehicleNames.includes(name)
	//       );

	//       setDuplicateImeis([]);
	//       setErrorVehicles([]);
	//       setErrorVehicles(matchedRows);
	//     } else {
	//       console.error("Upload failed:", err);
	//     }
	//   }
	// };

	const handleSubmit = async (values, { setSubmitting }) => {
		try {
			const formData = new FormData();
			formData.append("parentId", values.parent);

			if (values.parsedData && values.parsedData.length > 0) {
				const ws = XLSX.utils.json_to_sheet(values.parsedData);
				const wb = XLSX.utils.book_new();
				XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
				const excelBuffer = XLSX.write(wb, {
					bookType: "xlsx",
					type: "array",
				});
				const editedFile = new Blob([excelBuffer], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				});
				formData.append("file", editedFile, "edited_vehicles.xlsx");
			} else {
				formData.append("file", values.file[0]);
			}

			const res = await uploadVehicleFile(formData).unwrap();
			toast.success(trans("File uploaded successfully"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
			setBulkUpload(false);
			setDuplicateImeis([]);
			setErrorVehicles([]);
			setHasError("");
		} catch (err) {
			console.error("Upload error", err);

			// Handle duplicate IMEI error
			if (
				err?.status === 409 &&
				err?.data?.message?.includes("Duplicate IMEIs")
			) {
				// Extract all duplicate IMEIs from the message
				const imeiMatches = err.data.message.match(/\[(.*?)\]/);
				const duplicateImeis = imeiMatches
					? imeiMatches[1].split(",").map((imei) => imei.trim())
					: [];

				toast.error(trans("Duplicate IMEIs found"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});

				// Find which rows contain these IMEIs
				const errorRows = values.parsedData
					.map(
						(row, index) =>
							duplicateImeis.includes(row.imei) ? index + 1 : null // +1 because header row is index 0
					)
					.filter((index) => index !== null);

				setErrorVehicles(errorRows);
				setDuplicateImeis(duplicateImeis);
				setHasError(
					trans("Duplicate IMEIs found. Please correct the highlighted cells.")
				);
			} else {
				toast.error(trans("Upload failed. Please check the file."), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			}
		} finally {
			setSubmitting(false);
		}
	};

	const handleUploadAnotherFile = (formik) => {
		setDuplicateImeis([]);
		setErrorVehicles([]);
		setHasError("");
		formik.setFieldValue("file", []);
		formik.setFieldValue("parsedData", []);
	};

	const handleCancel = () => {
		setBulkUpload(false);
		setDuplicateImeis([]);
		setErrorVehicles([]);
		setHasError("");
	};
	return (
		<Popup show={!!bulkUpload} size={"xl"}>
			<Formik
				initialValues={initialValues}
				validationSchema={validationSchema}
				onSubmit={handleSubmit}
			>
				{(formik) => (
					<Form>
						<Modal.Header className="modal-header flex-between">
							<Modal.Title id="contained-modal-title-vcenter">
								<PopupTitle
									headtitle={trans(`Bulk Upload`)}
									subtitle={trans(`Please upload the file in xlsx format`)}
								/>
							</Modal.Title>
							<Close
								// eslint-disable-next-line react/style-prop-object
								style="close-32 close"
								close={() => handleCancel()}
								img="Close"
							/>
						</Modal.Header>
						<Modal.Body className="modal-body-scrollable">
							<>
								<InputParentGroup
									title={trans("Related to")}
									id="parent"
									name="parent"
									formstyle="form-input"
									onChange={(value) => formik.setFieldValue("parent", value)}
									onBlur={(value) => formik.setFieldTouched("parent", true)}
									value={formik.values.parent}
									errors={formik.errors.parent}
									touched={formik.touched.parent}
								/>
								{formik.values.parsedData.length === 0 ? (
									<>
										<UploadFile addData={formik} name="file" />
										{formik.touched.file && formik.errors.file && (
											<div className="text-danger mt-2">
												{formik.errors.file}
											</div>
										)}
									</>
								) : (
									<ExcelEditor
										file={formik.values.file[0]}
										onDataUpdate={(updated) =>
											formik.setFieldValue("parsedData", updated)
										}
										// errorRows={errorVehicles.map((_, idx) => idx)}
										errorRows={errorVehicles}
										duplicateImeis={duplicateImeis}
										imeiColumn="imei"
									/>

									// <PreviewFile
									//   data={formik.values.parsedData}
									//   duplicateImeis={duplicateImeis}
									//   errorVehicles={errorVehicles}
									// />
								)}
							</>
						</Modal.Body>
						<Modal.Footer>
							{hasError !== "" && (
								<div className="text-danger" dir="ltr">
									{hasError}
								</div>
							)}
							<Button
								type={"default"}
								htmlType="button"
								onClick={() => handleCancel()}
								text={trans("Cancel")}
							/>
							{hasError !== "" && (
								<Button
									type={"default"}
									danger={true}
									htmlType="button"
									text={trans("Upload Another File")}
									onClick={() => handleUploadAnotherFile(formik)}
								/>
							)}
							<Button
								type={"primary"}
								text={trans("Upload")}
								htmlType="submit"
								loading={isLoading}
								disabled={isLoading}
							/>
						</Modal.Footer>
					</Form>
				)}
			</Formik>
		</Popup>
	);
};

export default VehicleBulkUpload;
